<template>

<el-container class="app-container"
  :class="{
    'mini-side': isCollapse,
    'hide-side': hideSide
  }"
  >
  <el-aside class="app-side" :width="hideSide ? '0' : sideWidth + 'px'"
    :style="{background: theme.theme.backgroundColor}"
    >
    <!--<div class="app-header-logo-box"-->
      <!--:style="{height: headerHeight + 'px', color: theme.theme.activeTextColor}"-->
      <!--&gt;-->
      <!--<a href="/"><img src="../../assets/opwf_logo.png" alt="" class="header-logo"></a>-->
      <!--<span class="header-logo-text" ></span>-->
    <!--</div>-->
    <app-side :collapse="isCollapse" :theme="theme.theme"></app-side>
  </el-aside>
  <el-container style="overflow-x: auto">
    <el-header class="app-header" :height="headerHeight + 'px'">
      <app-header @switch="handleSideSwitch" @set-theme="handleSetTheme" @hide-side="handleSwitchHideSide"></app-header>
    </el-header>
    <el-main class="app-body">
      <el-container style="height: 100%;min-height: 100%;overflow: auto" id="appBody">
        <el-main class="app-page-body">
          <transition enter-active-class="animated bounceInLeft" leave-active-class="animated bounceOutRight">
            <router-view v-if="isRouterAlive"></router-view>
          </transition>
        </el-main>

        <!--<el-footer class="app-footer" :height="footerHeight + 'px'">-->
          <!--<app-footer></app-footer>-->
        <!--</el-footer>-->
      </el-container>
    </el-main>
  </el-container>
  <m-back-top body-id="appBody"></m-back-top>
</el-container>


</template>
<script type="text/javascript">
import AppHeader from '@/views/layout/app-header'
import AppFooter from '@/views/layout/app-footer'
import AppSide from '@/views/layout/app-side'
export default {
  name: 'app-view',
  provide: function () {
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      isRouterAlive: true,
      isCollapse: false,
      hideSide: false,
      sideWidth: 200,
      footerHeight: 50,
      headerHeight: 50,
      theme: {theme: {}},
      isShow: true,
    }
  },
  components: {
    AppHeader,
    AppFooter,
    AppSide
  },
  methods: {
    handleSideSwitch (val) {
      this.isCollapse = !val
      this.sideWidth = !val ? 60 : 200
    },

    handleSwitchHideSide () {
      this.hideSide = !this.hideSide
    },
    handleSetTheme (theme) {
      this.theme = theme
    },
    // 刷新方法
    reload: function () {
      this.isRouterAlive = false;
      // 该方法会在dom更新后执行
      this.$nextTick(function () { this.isRouterAlive = true })
    }
  }, created() {
    this.sideWidth = 60;
    this.isCollapse = true;
  }

}
</script>
<style type="text/css">
  .app-container{
    margin: 0 auto;
    position: absolute;
    width: 100%;
    height: 100%;
  }
  .app-container .app-header{
    padding: 0;
    background: #16AAD8;
    overflow: visible;
    z-index: 100;
  }
  .app-container .app-side{
    width: 200px;
    transition: all 0.5s ease;
  }
  .app-container .app-body{
    background: #ffffff;
    padding: 0;
  }
  .app-container .app-footer{
    background: #fff;
    border-top: solid 1px rgba(48, 54, 62, 0.14);
  }
  .app-container .app-page-body{
    overflow: visible;
    padding: 0px;
  }
  .app-header-logo-box{
    padding: 15px;
    box-sizing: border-box;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    background-color: #e4e4e4;
  }
  .app-header-logo-box .header-logo{
    height: 42px;
    margin-top: -17px;
    margin-right: 5px;
    vertical-align: middle;
  }
  .app-header-logo-box .header-logo-text{
    font-size: 20px;
    font-weight: bold;
    opacity: 1;
  }

  /*mini-side*/
  .app-container.mini-side .app-side{
    overflow: visible;
  }
  .app-container.mini-side .app-side .el-menu--collapse{
    width: 60px;
  }
  .app-container.mini-side .header-logo{
    margin-left: -10px;
  }
  .app-container.mini-side .header-logo-text{
    opacity: 0;
  }
  /*hide-side*/
  .app-container.hide-side .app-side{
    display: none;
  }
  .el-table .el-table__header thead th {
    color: #3c464e;
    background: #ffffff;
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/app-view.vue